import { PayCode, PayCodeOptionType } from 'components/PayCodeSelectInput/PayCodeSelectInput.types';

export const payCodeToOption = (payCode: PayCode): PayCodeOptionType => ({
  id: `${payCode.id}`,
  key: `${payCode.id}`,
  value: `${payCode.id}`,
  label: payCode.display_text,
  name: payCode.display_text,
});
